<div class="chapter" *ngIf="title">
  <a [routerLink]="link" class="title">
    {{ title | customLocale }}
    <app-icon class="title-icon" file="chevron" icon="right"></app-icon>
  </a>
</div>
